import { Heading } from 'blaze-ui/Heading/Heading'
import { Drawer } from 'components/Drawer'
import useShareSheetV2 from 'hooks/useShareSheetV2'
import { ShareSheetScreen, useShareSheetContext } from '../ShareSheetV2'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { InformalFeedbackRequest } from 'api/clients/InformalFeedbackRequestsClient'

interface Props {
  request?: InformalFeedbackRequest
}

export const MobileHeader = observer(({ request }: Props) => {
  const { setScreen, screen, file } = useShareSheetContext()
  const { asset } = useShareSheetV2(file)
  const { drawersStore } = useRootStore()

  let title: string = asset?.title || 'Share'
  if (screen === ShareSheetScreen.InviteAccess) {
    title = !request ? 'Invite people to review your work' : 'Edit access'
  }
  if (screen === ShareSheetScreen.EditAccess) title = 'Edit access'
  if (screen === ShareSheetScreen.ReviewSent) title = 'Invites sent'
  if (screen === ShareSheetScreen.PublicAccess) title = 'Share by Link'
  if (screen === ShareSheetScreen.ShowInviteToWorkspaceScreen) title = 'Invite new members to your workspace'

  const onBackPress = () => {
    if (screen === ShareSheetScreen.Default) {
      drawersStore.closeDrawer()
    } else {
      setScreen(ShareSheetScreen.Default)
    }
  }

  return (
    <Drawer.Top>
      {screen !== ShareSheetScreen.ReviewSent && screen !== ShareSheetScreen.Default ? (
        <Drawer.Back onPress={onBackPress} />
      ) : (
        <div />
      )}
      <Drawer.Title asChild>
        <Heading lineClamp={1} level={5}>
          {title}
        </Heading>
      </Drawer.Title>
      <Drawer.Close position="right" />
    </Drawer.Top>
  )
})
